import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from "@angular/core";

@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    public override parse(url: string): UrlTree {
        function toLowerCase(url: string): string {
            // check if there's a query string
            const [head, ...tail] = url.split('?');
            return [head.toLowerCase(), ...tail].join('?');
        }
        return super.parse(toLowerCase(url));
    }
}
